module.exports = {

  init() {

    lozad().observe();
    
    this.videoModal();
    
    this.cookie();
    
    this.testimonialSlider();
    
    this.blogSlider();
    
    this.reFilter();
      
    //this.mobileMenuToggle();
    
    this.pageOffset()
    
    this.fixedMenu()
    
    this.formChoice()
    
    this.homeSlider();
    
    this.mainSlider();

  },

  videoModal() {     
    
    var videoSrc = $("#videoModal iframe").attr("src");
    $('#videoModal').on('show.bs.modal', function () { // on opening the modal
      // set the video to autostart
      $("#videoModal iframe").attr("src", videoSrc+"?autoplay=1");
    }).on('hidden.bs.modal', function (e) { // on closing the modal
      // stop the video
      $("#videoModal iframe").attr("src", null);
    });

 
  },
  
  cookie() {
	  $(document).ready(function(){
	    $.cookieBar({
			message: "This website uses cookies to ensure you get the best experience on our website. For more information visit our <a href='/privacy-policy'>Privacy & Cookie Policy</a>.",
			acceptText: "I'm happy with that",
			fixed: true,
			policyButton: false,
			policyText: "Find out more",
			policyURL: "/privacy-policy"
		});
	  });  
	
  },
  
  testimonialSlider() {
  	const swiper = new Swiper('.testimonials-container', {
  	  // Optional parameters
  	  direction: 'horizontal',
  	  loop: true,
  	  speed: 400,
  	  slidesPerView: 1,
  	  spaceBetween: 80,
  	  // Responsive breakpoints
  	  autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
  	
  	 // If we need pagination
  	  pagination: {
  	    el: '.swiper-test-pagination',
  	    clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
  	  },
  	
  	  // Navigation arrows
  	  navigation: {
  	    nextEl: '.swiper-button-test-next',
  	    prevEl: '.swiper-button-test-prev',
  	  },
  	
  	 
  	});

  },
  
  blogSlider() {
  	const swiper = new Swiper('.blog-slider-container', {
  	  // Optional parameters
  	  direction: 'horizontal',
  	  loop: true,
  	  speed: 400,
  	  slidesPerView: 1,
  	  spaceBetween: 80,
  	  // Responsive breakpoints
  	  autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
  	
  	 // If we need pagination
  	  pagination: {
  	    el: '.swiper-blog-pagination',
  	    clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
  	  },
  	
  	  // Navigation arrows
  	  navigation: {
  	    nextEl: '.swiper-button-blog-next',
  	    prevEl: '.swiper-button-blog-prev',
  	  },
  	
  	 
  	});

  },
  
  reFilter(){

		$(document).on('click', '.load-more a:not(.current)', function (e) {
			  e.preventDefault();  
			  
			  var val = $(this).attr('data-attr');
			  $('#page_number option:gt(0)').remove();
			  $("#page_number").append('<option value='+ val +'>'+ val +'</option>');
			  $("#page_number").val(val).trigger('change');
			 	  
		});
	  
		jQuery(function($){
			$('#blog-category').on('change', function () {
				console.log("changed");
				var filter = $('#filter');
				$("#page_number").val('');
				$.ajax({
					url:filter.attr('action'),
					data:filter.serialize(), // form data
					
					type:filter.attr('method'), // POST
					beforeSend:function(xhr){
						
					},
					success:function(data){
					//console.log(data);
						
						$('#response').html(data); // insert data
					}
				});
				return false;
			});
		});	
		
		jQuery(function($){
			$('#page_number').on('change', function () {
				var filter = $('#filter');
				var blogs = $('.list');
				$.ajax({
					url:filter.attr('action'),
					data:filter.serialize(), // form data
					
					type:filter.attr('method'), // POST
					beforeSend:function(xhr){
						
					},
					success:function(data){
						$('.load-more').remove();
						var new_div = $(data).hide();
						$('#response').append(new_div);
						new_div.fadeIn('slow');
						//$(data).appendTo('#response').show('slow'); // insert data
/*
							$('html,body').animate({ 
								scrollTop: new_div.offset().top - 150
							}, 'fast'
						);
*/
	
	
						
					}
				});
				return false;
			});
		});	
	
  },
  
  pageOffset(){
    
    function pageOffsetFunction() {
    
      var headerHeight = $("#masthead").height();
      //console.log(headerHeight);
      $('#main').css('margin-top', headerHeight);
    
    }
    
    $(document).ready(pageOffsetFunction);
	  $(window).on('resize',pageOffsetFunction);
    
  },
  
  fixedMenu() {

  	window.onscroll = function() {myFunction()};
  
  	var header = document.getElementById("masthead");
  	var navbar = document.getElementById("navbar");
  	var sticky = navbar.offsetTop;
  	var body = document.body;
  
  	
  	function myFunction() {
  	  if (window.pageYOffset > sticky) {
  	    header.classList.add("sticky");
  	    body.classList.add("sticky");
  	  } else {
  	    header.classList.remove("sticky");
  	    body.classList.remove("sticky");
  	  }
  	  
  	}

  },
  
  mobileMenuToggle() {
	  
	  function myfunction() {

		  var width = $(window).width();
		  

		  if(width < 992){  			  
			
			$('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
				$(this).next('.dropdown-menu').toggleClass('show');	
			});
			
			$('.menu-item-has-children a.dropdown-toggle[href!="#"] span').on('click', function(e) { 	
				e.preventDefault(); 
				$(this).parent().next('.dropdown-menu').toggleClass('show');	
			});
			
		  } else {
			  
			  $('.menu-item-has-children .dropdown-menu').removeClass('show');
			  
			  $('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
			  });
			  
		  }

	  }
	  
	  $(document).ready(myfunction);
	  $(window).on('resize',myfunction);
	  
	 
  },
  
  formChoice(){
    
    $('.btn-contact').on('click', function(e) {  	
      e.preventDefault();
      $('.register-your-details').hide();
      $('#frm_form_1_container').show();
      $(this).removeClass('inactive');
      $('.btn-register').addClass('inactive');
    });
    $('.btn-register').on('click', function(e) {  	   
      e.preventDefault();  
      $('#frm_form_1_container').hide();
      $('.register-your-details').show();
      $(this).removeClass('inactive');
      $('.btn-contact').addClass('inactive');
    });
    
    
  },

  homeSlider() {
    const swiper = new Swiper('.home-slider-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 80,
      // Responsive breakpoints
      autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
    
     // If we need pagination
      pagination: {
        el: '.swiper-home-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-home-next',
        prevEl: '.swiper-button-home-prev',
      },
    
     
    });
  
  },
  
  mainSlider() {
    const swiper = new Swiper('.main-slider-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 80,
      // Responsive breakpoints
      autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
    
     // If we need pagination
      pagination: {
        el: '.swiper-main-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-main-next',
        prevEl: '.swiper-button-main-prev',
      },
    
     
    });
  
  },
  

}
